import { parseISO, isValid } from 'date-fns';
import { FormData } from '../features/add-well-test/services/addWellTestService';
import { TableDataItem } from '../types';

/**
 * Converts a date string (MM/DD/YYYY, MMM d yyyy, or ISO) to ISO string for the form.
 * Returns '' for empty/invalid dates to avoid "Invalid time value" when opening edit.
 */
function convertToISOString(dateStr: string | null | undefined): string {
  if (dateStr == null || String(dateStr).trim() === '') return '';
  const str = String(dateStr).trim();
  let date: Date;
  if (str.includes('/')) {
    const parts = str.split('/').map(Number);
    if (parts.length >= 3 && parts.every((n) => !Number.isNaN(n))) {
      const [month, day, year] = parts;
      date = new Date(Date.UTC(year, month - 1, day));
    } else {
      date = new Date(str);
    }
  } else {
    date = parseISO(str);
    if (!isValid(date)) date = new Date(str);
  }
  if (!isValid(date) || Number.isNaN(date.getTime())) return '';
  return date.toISOString();
}

export const mapTableDataToFormData = (data: TableDataItem): Partial<FormData> => {

  return {
    liquidFlowrate: data.LiquidFlowrate?.toString() || '',
    waterCut: data.WaterCut?.toString() || '',
    totalGasOilRatio: data.TotalGasOilRatio?.toString() || '',
    wellheadPressure: data.WellheadPressure?.toString() || '',
    wellheadTemperature: data.WellheadTemperature?.toString() || '',
    casingPressure: data.CasingPressure?.toString() || '',
    flowlinePressure: data.FlowlinePressure?.toString() || '',
    productionChokePosition: data.ProductionChokePosition?.toString() || '',
    pumpIntakePressure: data.PumpIntakePressure?.toString() || '',
    pumpIntakeTemperature: data.PumpIntakeTemperature?.toString() || '',
    pumpFrequency: data.PumpFrequency?.toString() || '',
    pumpDischargePressure: data.PumpDischargePressure?.toString() || '',
    waterDensity: data.WaterDensity?.toString() || '',
    comment: typeof data.Comment === 'string' ? data.Comment : '-',
    enabled: data.Enabled === 'N' ? false : true,
    date: convertToISOString(data.Date),
    wellId: data.WellId || 0,
    methodOfProduction: data.MethodOfProduction || '',
    id: data.Id || 0,
    oil: data.Oil?.toString() || '',
    water: data.Water?.toString() || '',
    gas: data.Gas?.toString() || '',
    downholePressure: data.DownholePressure?.toString() || '',
    downholeTemperature: data.DownholeTemperature?.toString() || '',
    resultsPwf: data.ResultsPwf?.toString() || '',
    productivityIndex: data.ProductivityIndex?.toString() || '',
    injectionRate: data.InjectionRate?.toString() || '',
    flowPath: data.FlowPath !== undefined ? Number(data.FlowPath) : 0,
    annulusChokeSettings: data.AnnulusChokeSettings === '-' ? null : data.AnnulusChokeSettings,
    hasStandardDeviation: data.HasStandardDeviation || false,
    hasTestWarnings: data.HasTestWarnings === 'N' ? false : true,
    isQuestionable: data.IsQuestionable || false,
  };
};
